


exports.commonRequestTimeout = '10000',
exports.baseUrl = process.env.REACT_APP_API_URL;
// exports.baseUrl = "http://localhost:8080";
// exports.baseUrl = "https://restapi-stg1.mygameuk.co.uk"
// exports.baseUrl = "https://mygame-app-dev.mypartypokerlive.com"
exports.domain = process.env.REACT_APP_DOMAIN;
exports.facebook_appId = process.env.REACT_APP_FACEBOOK_APP_ID;
exports.tournamentHourFilter = process.env.REACT_APP_TOURNAMENT_HOUR_FILTER;
exports.tournamentTimezone = process.env.REACT_APP_TOURNAMENT_TIMEZONE
exports.partypoker_login_url = process.env.REACT_APP_PARTYPOKER_LOGIN_URL
exports.partypoker_redirect_uri = process.env.REACT_APP_PARTYPOKER_REDIRECT_URI
// exports.partypoker_redirect_uri = "http://localhost:3000/clientLogin"
exports.partypoker_login_rurl = process.env.REACT_APP_PARTYPOKER_LOGIN_RURL;
exports.redirectToMyGame= process.env.REACT_APP_MYGAMEREDIRECTURIFrmClient
exports.mppl_redirect_uri = process.env.REACT_APP_MPPL_REDIRECT_URI
exports.secretKey = process.env.REACT_APP_SECRETKEY
exports.mppl_redirect_uri = 'http://192.168.1.131:3000/dashboard'
// exports.secretKey = 'pokerWatchGame'
exports.adminSubDomain = "mygameadmin-dev"
// exports.redirectURI = 'https://localhost/login'
// exports.clientLoginURL = 'https://releaseb-ciwic.ivycomptech.co.in/en_US/VC/login-mygame.html'
// exports.redirectToMyGame= 'https://localhost/RedirectToMyGameFrmClient'
// exports.PPLogin ='https://account.partypoker.com/en_US/VC/login-mygame.html?redirect_URI=https://mygame-local.mypartypokerlive.com/'
exports.enable_language = "on";
exports.partyBrands = ["PartyPoker","PARTYPOKER","PARTYONCA","PPDE", "PPIT","PARTYSE","PARTYDK"];


/** WEBPACK FOOTER **
 ** ./src/common/config.js
 **/